import PropTypes from "prop-types"
import React from "react"

import Heading from "src/components/Heading"

const MarinaHeader = ({ marina, onCall }) => (
  <div className="flex items-center space-x-4 border-b border-gray-300 pb-6">
    <img
      src={marina.image}
      alt={marina.name}
      className="h-[160px] w-[240px] shrink-0 rounded-lg object-cover"
    />
    <div className="flex flex-col space-y-3">
      <Heading.HeroTitle>{marina.name}</Heading.HeroTitle>
      <div className="flex flex-wrap gap-x-6 gap-y-1 font-semibold text-gray-700">
        {marina.address && (
          <span>
            <i className="fa-solid fa-location-dot mr-1 text-red-500" />
            {marina.address}
          </span>
        )}
        {marina.phone && (
          <a
            href={`tel:${marina.phone}`}
            className="text-blue-600"
            onClick={onCall}
          >
            <i className="fa-solid fa-phone mr-1" />
            {marina.phone}
          </a>
        )}
      </div>
    </div>
  </div>
)

MarinaHeader.propTypes = {
  marina: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string,
    phone: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  onCall: PropTypes.func,
}

export default MarinaHeader
